module.exports = [
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Box pro set s hlavovou sprchou 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Nástěnné kolínko, DN 15",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Sprchová tyč, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34256004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34256004/640/34256004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34256004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34256004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Vanová napouštěcí, odtoková a přepadová souprava",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat s podomítkovou instalací s dvěma\nventily a integrovaným držákem na sprchu",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily, integrovaný vývod sprchy Čtvercový tvar, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat s podomítkovou instalací s dvěma\nventily a integrovaným držákem na sprchu",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily, integrovaný vývod sprchy Zaoblené tvary, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "Termostatická sprchová baterie GROHE Grohtherm 1000 Cosmopolitan M se sprchovým setem GROHE Euphoria 110 Massage, 600mm sprchová tyč",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Nástěnný držák sprchy",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Nástěnné kolínko, DN 15",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Sprchová tyč, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34195001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34321002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34321002/640/34321002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34321002",
		"textblock_2nd_text": "Termostatická sprchová baterie GROHE Grohtherm 1000 Cosmopolitan M se sprchovým setem GROHE Euphoria 110 Massage, 900 mm sprchová tyč",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34321002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "Eurocube",
		"subheadline": "Vanová vpusť",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Sprchová tyč set 1 proud",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Vanová vpusť",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Kombinace proti zpětnému toku (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Podomítkové těleso pro nástěnné kombinace/varianty",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34565001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Sprchový systém s hlavovou sprchou Rainshower 310 SmartActive",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Sprchový set s termostatickou baterií Grohtherm SmartControl Perfect, pro podomítkovou instalaci se třemi ventily, hlavová sprcha, ruční sprcha, sprchové rameno, hadice. Kruhový tvar. Chromový povrch, vyrobeno v Německu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Vanová vpusť",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Nástěnné kolínko, DN 15",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Rameno sprchové výpusti Eurocube, chromový povrch, vyrobeno v Německu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34566001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "Komfortní sprchový set GROHE Grohtherm 3000 Cosmopolitan včetně podomítkové sprchové baterie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Sprchová hadice 1250",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "Hadice GROHE SilverFlex s flexibilním konektorem TwistFree, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Sprchová hadice 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "Hadice GROHE SilverFlex s flexibilním konektorem TwistFree, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower 210",
		"textblock_1st_text": "34408000",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm 3000 Cosmopolitan Perfect s kovovou hlavovou sprchou Rainshower Cosmopolitan 210 mm, ruční sprchou Euphoria 110 mm a termostatickým tělesem Rapido T určeným pro podomítkovou instalaci.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Sprchový set vhodný pro Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm Cube Perfect s hlavovou sprchou Rainshower Allure 230 mm, ruční sprchou Euphoria Cube a termostatickým tělesem Rapido T určeným pro podomítkovou instalaci.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34283001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34283001/640/34283001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Sprchový set vhodný pro Power&Soul Cosmopolitan 190",
		"textblock_1st_text": "34283001",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm 2000 Perfect, včetně termostatické baterie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34283001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23409000",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23409000/640/23409000.jpg",
		"headline": "Eurocube",
		"subheadline": "Sprchový set s Euphoria Cube 152",
		"textblock_1st_text": "23409000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/23409000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G318",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 3 ventily. Zaoblené tvary, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Sprchová hadice 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "Hadice GROHE SilverFlex s flexibilním konektorem TwistFree, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 DUO Exposed s termostatickou sprchovou baterií. Chromový, ekologický, precizně vyrobený v Německu, 360mm hlavová sprcha s režimem proudu GROHE TrioMassage a 115mm ruční sprcha se dvěma režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sprchový systém s jednopákovou baterií na omítku",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria XXL Shower System s pákovou baterií, chromový povrch, vyrobeno v Německu, obsahuje kovovou, 230mm hlavovou sprchu a ruční sprchu s jedním režimem proudu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Univerzální vestavbové těleso DN 15",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily. Čtvercový tvar, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 3 ventily. Čtvercový tvar, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 1 ventil Čtvercové tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily. Čtvercové tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 3 ventily. Čtvercové tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 1 ventil Zaoblené tvary, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily. Zaoblené tvary, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 1 ventil Zaoblené tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s 2 ventily",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 2 ventily. Zaoblené tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s třemi ventily",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Termostatická sprchová nebo vanová baterie Grohtherm SmartControl pro podomítkovou instalaci, 3 ventily. Zaoblené tvary, povrchová úprava Moon White, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostat pro podomítkovou instalaci s jedním ventilem",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Termostatická sprchová baterie Grohtherm SmartControl pro podomítkovou instalaci, 1 ventil Čtvercový tvar, chromová povrchová úprava, vyrobeno v Německu společností GROHE. Ekologický provoz a bezpečnostní technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm 3000 Cosmopolitan Perfect s kovovou hlavovou sprchou Rainshower Cosmopolitan 310 mm, ruční sprchou Sena a termostatickým tělesem Rapido T určeným pro podomítkovou instalaci.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Sprchový set vhodný pro Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm 3000 Cosmopolitan Perfect s kovovou hlavovou sprchou Rainshower Cosmopolitan 310 mm, ruční sprchou Sena a termostatickým tělesem Rapido T určeným pro podomítkovou instalaci.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Sprchový set Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Sprchový set GROHE Grohtherm 2000 Perfect s hlavovou sprchou Rainshower Cosmopolitan 210 mm, ruční sprchou Euphoria Cosmopolitan a termostatickým tělesem Rapido T určeným pro podomítkovou instalaci.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Univerzální vestavbové těleso DN 15",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Perfektní sprchový set s Tempesta 210",
		"textblock_1st_text": "25183001",
		"textblock_2nd_text": "Sprchový systém GROHE Eurosmart Cosmopolitan Perfect s pákovou baterií určený pro podomítkovou instalaci, obsahuje 210mm hlavovou sprchu a 100mm ruční sprchu se dvěma režimy proudu, chromový povrch.  Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (130 mm), tyčí (900 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (160 mm), tyčí (900 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26072000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26072000/640/26072000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26072000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180, set s nástěnnou hlavovou sprchou, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26072000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Ruční sprcha 4+ proudy",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan 130, ruční sprcha, 4+ režimů proudu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Sprchový set s tyčí, 2 proudy",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan s ruční sprchou (130 mm), tyčí (900 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan s ruční sprchou (160 mm), tyčí (900 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 210 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 310 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 310 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Set s držákem 4+ proudy",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26060000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26060000/640/26060000.jpg",
		"headline": "Rainshower F-Series 10' 254 x 254",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26060000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26060000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hlavová sprcha set stropní 154 mm, 1 proud",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Sprchová tyč set 1 proud",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Hlavová sprcha set 286 mm, 1 proud",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (130 mm), tyčí (600 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Sprchový set s tyčí, 2 proudy",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (115 mm), tyčí (900 mm) a hadicí (1 750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Set s držákem 2 proudy",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (115 mm), hadicí (1 250 mm) a držákem sprchy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Set s držákem 2 proudy",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "Set GROHE Power&Soul Cosmopolitan s ruční sprchou (115 mm), hadicí (1 250 mm) a držákem sprchy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "Set GROHE Power&Soul s ruční sprchou (130 mm), tyčí (600 mm) a hadicí (1 750 mm), 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Exposed s termostatickou sprchovou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha a 115mm ruční sprcha se čtyřmi režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Vanová napouštěcí, odtoková a přepadová souprava",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sprchový systém s jednopákovou baterií na omítku",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "Sprchový systém GROHE Tempesta Cosmopolitan 210 Shower System s pákovou baterií, obsahuje 210mm hlavovou sprchu a 100mm ruční sprchu se dvěma režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "New Tempesta System 210",
		"subheadline": "Nástěnný Flex sprchový systém s přepínačem",
		"textblock_1st_text": "26381001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26256000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26256000/640/26256000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26256000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26256000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26255000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26255000/640/26255000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Set s hlavovou sprchou 422 mm, 1 proud",
		"textblock_1st_text": "26255000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26255000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s vanovým termostatem na zeď",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou baterií a vanovou výpustí",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Ruční sprcha",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sprchová souprava s termostatickou baterií na omítku",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria Cube XXL 230 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower Cosmopolitan 310, set hlavové sprchy, stropní rameno sprchy 142 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Sprchová souprava s termostatickou baterií na omítku",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria XXL Shower System s termostatickou baterií, chromový povrch, vyrobeno v Německu, obsahuje kovovou, 310mm hlavovou sprchu a 110mm ruční sprchu se třemi režimy proudu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Boční sprcha s jedním proudem",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26057000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26057000/640/26057000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26061000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26061000/640/26061000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Hlavová sprcha set stropní 142 mm, 1 proud",
		"textblock_1st_text": "26061000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26061000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Ruční sprcha",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s termostatem a bočními sprchami",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou baterií a tělovými tryskami",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sprchový systém",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 210 s přepínacím ventilem",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower 400 s termostatickou baterií",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Set s hlavovou sprchou 422 mm, 1 proud",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Nástěnný držák sprchy",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set 380 mm, 1 proud",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hlavová sprcha set 380 mm, 1 proud",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26446LS0",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Combi s termostatickou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha (bílý sprchový disk) a 115mm ruční sprcha se čtyřmi režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Kombinovaná sprchová termostatická baterie se 3 ventily, nástěnná",
		"textblock_1st_text": "34713000",
		"textblock_2nd_text": "Sprchová termostatická baterie GROHE Grohtherm SmartControl Combi se třemi ventily. Chromová barva s bílou přihrádkou, německá kvalita.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Ruční sprcha 2 proudy, bílá spodní část sprchy",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26363000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26363000/640/26363000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26363000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26363000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26250LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Exposed s termostatickou sprchovou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha (bílý sprchový disk) a 115mm ruční sprcha se čtyřmi režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Kombinovaná sprchová termostatická baterie s 2 ventily, nástěnná",
		"textblock_1st_text": "34714000",
		"textblock_2nd_text": "Sprchová termostatická baterie GROHE Grohtherm SmartControl Combi se dvěma ventily. Chromová barva s bílou přihrádkou, německá kvalita.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Sprchový set s tyčí 4+ proudy",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Set s hlavovou sprchou 450 mm, 1 proud",
		"textblock_1st_text": "26450000",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 360 MONO. Chromová, vyrobená v Německu: 360mm hlavová sprcha a 450mm sprchové rameno.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Perfektní sprchový set s Tempesta 210",
		"textblock_1st_text": "34614001",
		"textblock_2nd_text": "Sprchový systém GROHE Grohtherm 1000 Perfect, obsahuje 210mm hlavovou sprchu a 100mm ruční sprchu se dvěma režimy proudu, chromový povrch.  Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "Sprchový systém GROHE Tempesta Cosmopolitan 210 Shower System s termostatickou baterií, obsahuje 210mm hlavovou sprchu a 100mm ruční sprchu se dvěma režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower 360 Mono",
		"subheadline": "Set s hlavovou sprchou 450 mm, 1 proud",
		"textblock_1st_text": "26450LS0",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 360 MONO. Chromová, vyrobená v Německu: 360mm hlavová sprcha (bílý sprchový disk) a 450mm sprchové rameno.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 DUO Combi s termostatickou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha s režimem proudu GROHE TrioMassage a 115mm ruční sprcha se dvěma režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl 360 DUO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 DUO Combi s termostatickou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha (bílý sprchový disk) s režimem proudu GROHE TrioMassage a 115mm ruční sprcha se dvěma režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl 360 MONO",
		"subheadline": "Kombinovaný sprchový systém s termostatem, nástěnný/podomítkový",
		"textblock_1st_text": "26446000",
		"textblock_2nd_text": "Sprchový systém GROHE Rainshower SmartControl 360 MONO Combi s termostatickou baterií. Chromový, ekologický a vyrobený v Německu: 360mm hlavová sprcha a 115mm ruční sprcha se čtyřmi režimy proudu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sprchový systém s vanovým termostatem na zeď",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "Sprchový systém GROHE Tempesta Cosmopolitan 210 Shower System s termostatickou baterií určený pro vany, obsahuje 210mm hlavovou sprchu a 100mm ruční sprchu se dvěma režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Sprchový systém s hlavovou sprchou Rainshower 310 SmartActive Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Sprchový set s termostatickou baterií Grohtherm SmartControl Perfect, pro podomítkovou instalaci se třemi ventily, hlavová sprcha, ruční sprcha, sprchové rameno, hadice. Čtvercový tvar. Chromový povrch, vyrobeno v Německu.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s termostatickou baterií, obsahuje 260mm hlavovou sprchu SmartControl se třemi režimy proudu a 110mm ruční sprchu se třemi režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s vanovým termostatem na zeď",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "Vanový/sprchový systém GROHE Euphoria 260 Shower System s termostatickou vanovou baterií, obsahuje 260mm hlavovou sprchu SmartControl se třemi režimy proudu a 110mm ruční sprchu se třemi režimy proudu, chromový povrch. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s jednopákovou baterií na omítku",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s pákovou baterií, obsahuje 260mm hlavovou sprchu SmartControl se třemi režimy proudu a 110mm ruční sprchu se třemi režimy proudu, chromový povrch. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém",
		"textblock_1st_text": "27421002",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s přepínačem. Úsporná, 260mm hlavová sprcha SmartControl se třemi režimy proudu a 110mm, chromová ruční sprcha se třemi režimy proudu. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sprchový systém s termostatem na zeď",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "Sprchový systém GROHE Euphoria 260 Shower System s termostatickou baterií, obsahuje 260mm hlavovou sprchu SmartControl se třemi režimy proudu a 110mm ruční sprchu se třemi režimy proudu, chromový povrch. Snadná instalace a údržba. Německé řemeslnictví.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Termostatická sprchová baterie, DN 15 se sprchovou soupravou",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Ruční sprcha 4+ proudy, bílá spodní část sprchy",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Hlavová stropní sprcha 380 mm, 3 proudy",
		"textblock_1st_text": "26458000",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Euphoria 260 SmartControl se třemi režimy proudu. 260mm hlavová sprcha GROHE Rainshower se sprchovým ramenem (380 mm) a chromovou povrchovou úpravou. Snadná instalace a údržba. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive se 2 režimy proudu vody. 310mm, stropní hlavová sprcha se 142mm sprchovým ramenem, chromová povrchová úprava s bílým diskem, kruhový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive se 2 režimy proudu vody. 310mm, stropní hlavová sprcha se 142mm sprchovým ramenem, chromová povrchová úprava, kruhový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower 310 SmartActive",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive se 2 režimy proudu vody. 310mm, nástěnná hlavová sprcha se 400mm sprchovým ramenem, chromová povrchová úprava s bílým diskem, kruhový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Hlavová stropní sprcha 142 mm, 3 proudy",
		"textblock_1st_text": "26460000",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Euphoria 260 SmartControl se třemi režimy proudu. 260mm hlavová sprcha GROHE Rainshower se stropním ramenem (142 mm) a chromovou povrchovou úpravou. Snadná instalace a údržba. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive CUBE se 2 režimy proudu vody. 310mm, stropní hlavová sprcha se 142mm sprchovým ramenem, chromová povrchová úprava s bílým diskem, čtvercový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive CUBE se 2 režimy proudu vody. 310mm, stropní hlavová sprcha se 142mm sprchovým ramenem, chromová povrchová úprava, čtvercový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower 310 SmartActive Cube",
		"subheadline": "Set hlavové sprchy se 2 režimy proudu",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "Set hlavové sprchy GROHE Rainshower 310 SmartActive CUBE se 2 režimy proudu vody. 310mm, nástěnná hlavová sprcha se 400mm sprchovým ramenem, chromová povrchová úprava s bílým diskem, čtvercový tvar. Vyrobeno v Německu",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.cz/cs_cz/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.cz/cs_cz/nase-sluzby/showroomy-instalateri/showroom-locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/shower_products_cs_cz.json
// module id = 820
// module chunks = 0